import React, {Component} from 'react';
import {ISsqDataDocument} from "../repositories/SsqDataRepository";
import {SsqImages} from "../images/SsqImages";
import {getTextFromHtml} from "../util/commonUtils";
import {LanguageService} from "language/LanguageService";
import {langutil} from "language/langutil";
import {connect} from 'react-redux';
import {IfLoginInfo} from "models/IfLoginInfo";
import {loginutil} from "util/loginutil";
import {withLoginPopup} from "hoc/withLoginPopup";

interface Props {
  ssqDocument: ISsqDataDocument;
  getTranslation: Function;
  languageService: LanguageService;
  loginInfo: IfLoginInfo;
  showLoginPopup: (show: boolean) => void;
}


class TechnicalDocumentListItem extends Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    const {loginInfo, ssqDocument, showLoginPopup} = this.props;

    return <div className={"result-item"}>
      <div className={"result-item-tit"}>
        <div className={"page-name tit"}>
          <span
            onClick={() => {
              if (!loginutil.hasDocViewAuth(loginInfo, ssqDocument.displayTarget)) {
                if (loginutil.islogin(loginInfo)) {
                  loginutil.alertDocView(loginInfo, ssqDocument.displayTarget);
                } else {
                  showLoginPopup(true);
                }
                return;
              }
              window.open(`/${country}/${lang}/community/blog/document/${this.props.ssqDocument.id}`, "_blank");
            }}>{getTextFromHtml(this.props.ssqDocument.docTitle)}</span>
          {this.props.ssqDocument.displayTarget == 15 &&
            <div>
              <p className={"partner"}>{this.props.getTranslation("I18N_SOLUTION_PARTNER")}</p>
            </div>}
          {this.props.ssqDocument.displayTarget == 20 &&
            <div><p
              className={"level"}>{this.props.getTranslation("I18N_SOLUTION_EMPLOYEE")}</p>
            </div>}
        </div>
      </div>
      <div className={"result-item-info " + (this.props.ssqDocument.imageUrl && "result-item-img-info")}>
        {this.props.ssqDocument.imageUrl && <div className={"img-wrap"}>
          <img
            src={`/uploads/${this.props.ssqDocument.imageUrl}`}
            onError={(e: any) => {
              e.target.src = SsqImages.common.icon.noImage();
              e.target.className = "no-image";
              e.target.alt = "no_image.svg";
            }}
            onClick={() => {
              if (!loginutil.hasDocViewAuth(loginInfo, ssqDocument.displayTarget)) {
                if (loginutil.islogin(loginInfo)) {
                  loginutil.alertDocView(loginInfo, ssqDocument.displayTarget);
                } else {
                  showLoginPopup(true);
                }
                return;
              }
              window.open(`/${country}/${lang}/community/blog/document/${this.props.ssqDocument.id}`, "_blank");
            }}
          />
        </div>}
        <div className={"txt-wrap"}>
          <div className={"desc-wrap"}>
            <span
              onClick={() => {
                if (!loginutil.hasDocViewAuth(loginInfo, ssqDocument.displayTarget)) {
                  if (loginutil.islogin(loginInfo)) {
                    loginutil.alertDocView(loginInfo, ssqDocument.displayTarget);
                  } else {
                    showLoginPopup(true);
                  }
                  return;
                }
                window.open(`/${country}/${lang}/community/blog/document/${this.props.ssqDocument.id}`, "_blank");
              }}>{getTextFromHtml(this.props.ssqDocument.description)}</span>
          </div>
          {this.props.ssqDocument.productCategoryNames.length > 0 && <div className={"txt_bt"}>
            <div className={"related_bt"}>

              <span>{this.props.getTranslation("I18N_SOLUTION_RELATED")}</span>
              <span className={"line"}/>
              {this.props.ssqDocument.productCategoryNames.map((category, index) => {
                return <span key={index}>
                                    <span>{category}</span>
                  {this.props.ssqDocument.productCategoryNames.length > index + 1 &&
                    <span className={"comma"}>,</span>}
                                </span>;
              })}</div>
          </div>}
          <div className={"tit-txt"}>
                        <span className={"read"}>
                    {this.props.getTranslation("I18N_SOLUTION_CLICK_COUNT")}
                          <b>{this.props.ssqDocument.clickCount}</b></span>
          </div>
        </div>
      </div>
    </div>;
  }
}

export default connect(
  (state: any) => ({
    loginInfo: state.main.loginInfo,
  })
)(withLoginPopup(TechnicalDocumentListItem));